import { render, staticRenderFns } from "./DefaultProfileV2.vue?vue&type=template&id=3ffe0982&scoped=true"
import script from "./DefaultProfileV2.vue?vue&type=script&lang=js"
export * from "./DefaultProfileV2.vue?vue&type=script&lang=js"
import style0 from "./DefaultProfileV2.vue?vue&type=style&index=0&id=3ffe0982&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffe0982",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ffe0982')) {
      api.createRecord('3ffe0982', component.options)
    } else {
      api.reload('3ffe0982', component.options)
    }
    module.hot.accept("./DefaultProfileV2.vue?vue&type=template&id=3ffe0982&scoped=true", function () {
      api.rerender('3ffe0982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profiles/DefaultProfileV2.vue"
export default component.exports